import { faBriefcase, faFileAlt, faCheckCircle, faGift, faInfoCircle, faCog, faCalendarDay, faCartPlus, faArrowLeft, faMoneyBill, faCreditCard, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { faClipboardCheck, faFlag, faLocationArrow, faClock  } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';
import { faMoneyBillAlt } from '@fortawesome/free-regular-svg-icons';
import { faUser, faEnvelope, faPhone, faMapMarker, faTag, faPlus, faSearch, faTrash, faPen, faCamera, faLock, faTimes, faTruck, faGlobeAmericas, faCity, faHome, faMailBulk, faIdCard, faShoppingBag, faShapes, faSquare, faArrowAltCircleDown, faArrowDown, faBoxOpen, faBox, faBoxes, faDollarSign, faToggleOn, faBarcode, faEllipsisV, faPlay, faCircle, faChartBar, faThLarge } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [FontAwesomeModule]
})
export class IconSetModule {
  public icons: IconDefinition[];
  constructor(private library: FaIconLibrary) {
    this.icons = [
      faUser,
      faEnvelope,
      faPhone,
      faMapMarker,
      faTag,
      faSearch,
      faPlus,
      faTrash,
      faGoogle,
      faFacebookF,
      faApple,
      faPen,
      faCamera,
      faLock,
      faTimes,
      faBriefcase,
      faFileAlt,
      faCheckCircle,
      faGift,
      faInfoCircle,
      faCog,
      faCalendarDay,
      faClipboardCheck,
      faFlag,
      faLocationArrow,
      faClock,
      faTruck,
      faGlobeAmericas,
      faCity,
      faHome,
      faMailBulk,
      faIdCard,
      faShoppingBag, // supplier
      faShapes, // categories
      faSquare, // subcatgory
      faBoxOpen, // product
      faBox, // product
      faBoxes, // products,
      faDollarSign, // price - cost
      faToggleOn, // available
      faBarcode, // barcode
      faCartPlus, // additional
      faArrowLeft, // back
      faMoneyBill,
      faCreditCard,
      faCircle,
      faLayerGroup,
      faEllipsisV,
      faPlay,
      faChartBar,
      faThLarge, // floor plan
    ];
    library.addIcons(...this.icons);
  }
}
